<template>
  <div class="scoring-panel" :style="{ width: panelWidth + 'px' }">
    <div class="resize-handle" @mousedown="startResize"></div>
    <div class="content">
      <button class="close-btn" @click="closePage">X</button>

      <h1>Scoring Sheet</h1>
      
      <div class="toggle-container">
        <button class="toggle-btn" :class="{ 'active': showAdvancedTasks }" @click="showAdvancedTasks = !showAdvancedTasks">
          <span class="toggle-switch"></span>
        </button>
      </div>

      <div class="trails-container">
        <ScoreSection 
          taskName="Trails" 
          route="/trail-making/a"
          :currentRoute="currentRoute"
          class="trails-section"
        >
          <div class="trail-making-layout">
            <div class="trail-section">
              <div class="trail-header">A:</div>
              <div class="trail-scores">
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingA ? (jsonData.trailMakingA.time || 0) : 0 }}</div>
                  <div class="score-label">Time (s)</div>
                </div>
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingA ? (jsonData.trailMakingA.errors || 0) : 0 }}</div>
                  <div class="score-label">Errors</div>
                </div>
              </div>
            </div>
            <div class="trail-section">
              <div class="trail-header">B:</div>
              <div class="trail-scores">
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingB ? (jsonData.trailMakingB.time || 0) : 0 }}</div>
                  <div class="score-label">Time (s)</div>
                </div>
                <div class="trail-score-item">
                  <div class="score-box">{{ jsonData && jsonData.trailMakingB ? (jsonData.trailMakingB.errors || 0) : 0 }}</div>
                  <div class="score-label">Errors</div>
                </div>
              </div>
            </div>
          </div>
        </ScoreSection>

        <div class="info-box">
          <div class="info-row">
            <span class="info-label">Char ID:</span>
            <input type="text" class="info-input-box-wide" />
          </div>
          <div class="info-row">
            <span class="info-label">Date:</span>
            <input type="text" class="info-input-box-wide" />
          </div>
          <div class="info-row">
            <span class="info-label">Visit No.:</span>
            <input type="text" class="info-input-box-wide" />
          </div>
          <div class="info-row">
            <span class="info-label">Visit Type:</span>
            <span class="info-value">2- In-Person</span>
          </div>
          <div class="info-row">
            <span class="info-label">Interviewer:</span>
            <input type="text" class="info-input-box-wide" />
          </div>
        </div>
      </div>

      <div :class="{ 'greyed-out': !showAdvancedTasks }">
        <ScoreSection 
          taskName="CONST. PRAXIS" 
          :isDisabled="true"
        >
          <div class="const-praxis-content">
            <div class="const-praxis-section">
              <div class="const-praxis-label">INITIAL:</div>
              <div class="const-praxis-items">
                <div class="const-praxis-item">
                  <span class="item-number">1.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Circle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">2.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Diamond</span>
                  <span class="const-score-placeholder">3</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">3.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Rectangle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">4.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Cube</span>
                  <span class="const-score-placeholder">4</span>
                </div>
              </div>
            </div>
            <div class="const-praxis-section">
              <div class="const-praxis-label">RECALL:</div>
              <div class="const-praxis-items">
                <div class="const-praxis-item">
                  <span class="item-number">1.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Circle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">2.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Diamond</span>
                  <span class="const-score-placeholder">3</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">3.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Rectangle</span>
                  <span class="const-score-placeholder">2</span>
                </div>
                <div class="const-praxis-item">
                  <span class="item-number">4.</span>
                  <input type="text" class="const-input" />
                  <span class="const-shape-label">Cube</span>
                  <span class="const-score-placeholder">4</span>
                </div>
              </div>
            </div>
          </div>
        </ScoreSection>

        <ScoreSection 
          taskName="WORD LIST MEMORY TASK" 
          :isDisabled="true"
        >
          <ScoreRow label="Score:" :score="0" />
        </ScoreSection>

        <ScoreSection 
          taskName="MATTIS" 
          :isDisabled="true"
        >
          <ScoreRow label="Score:" :score="0" />
        </ScoreSection>
      </div>

      <ScoreSection 
        taskName="Clock Drawing" 
        route="/clock-drawing"
        :currentRoute="currentRoute"
      >
        <ScoreRow label="Score:" :score="clockDrawingScore" />
      </ScoreSection>

      <ScoreSection 
        taskName="Verbal Fluency, Supermarket" 
        route="/verbal-fluency/supermarket/transcription"
        :currentRoute="currentRoute"
      >
        <ScoreRow label="Total Correct:" :score="supermarketCorrect" />
        <ScoreRow label="Total Incorrect:" :score="supermarketIncorrect" />
        <ScoreRow label="Total Repetitions:" :score="supermarketRepetitions" />
      </ScoreSection>

      <ScoreSection 
        taskName="Verbal Fluency, Letter F" 
        route="/verbal-fluency/letter-f/transcription"
        :currentRoute="currentRoute"
      >
        <ScoreRow label="Total Correct:" :score="letterFCorrect" />
        <ScoreRow label="Total Incorrect:" :score="letterFIncorrect" />
        <ScoreRow label="Total Repetitions:" :score="letterFRepetitions" />
      </ScoreSection>

      <ScoreSection 
        taskName="CASI" 
        route="/CASI"
        :currentRoute="currentRoute"
      >
        <ScoreRow label="Attention Score:" :score="casiATT" />
        <ScoreRow label="Mental Manipulation/Concentration Score:" :score="casiMMC" />
        <ScoreRow label="Orientation Score:" :score="casiORI" />
        <ScoreRow label="Long-term Memory Score:" :score="casiLTM" />
        <ScoreRow label="Short-term Memory Score:" :score="casiSTM" />
        <ScoreRow label="Language Score:" :score="casiLANG" />
        <ScoreRow label="Visual Construction Score:" :score="casiDRAW" />
        <ScoreRow label="List-generating Fluency Score:" :score="casiFLU" />
        <ScoreRow label="Abstraction and Judgment Score:" :score="casiATAJ" />
        <ScoreRow label="Total Score:" :score="totalScore" class="total-score"/>
      </ScoreSection>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ScoreSection from './ScoreSection.vue';
import ScoreRow from './ScoreRow.vue';
import CASIController from '../controllers/CASIController';
import { getSubjectData } from '../utils/storage';
import { eventBus } from '../utils/eventBus';

export default {
  components: {
    ScoreSection,
    ScoreRow
  },
  data() {
    return {
      controller: new CASIController(),
      jsonData: {},
      clockDrawingScore: 0,
      letterFCorrect: 0,
      letterFIncorrect: 0,
      letterFRepetitions: 0,
      supermarketCorrect: 0,
      supermarketIncorrect: 0,
      supermarketRepetitions: 0,
      totalScore: 0,
      casiATT: 0,
      casiMMC: 0,
      casiORI: 0,
      casiLTM: 0,
      casiSTM: 0,
      casiLANG: 0,
      casiDRAW: 0,
      casiFLU: 0,
      casiATAJ: 0,
      isResizing: false,
      startX: 0,
      startWidth: 0,
      showAdvancedTasks: false,
    };
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.loadAllData();
      }
    }
  },
  async mounted() {
    await this.loadData();
    this.calculateScores();
    this.loadAllData();
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    panelWidth: {
      type: Number,
      default: 775,
    },
    ...['totalScore', 'casiATT', 'casiMMC', 'casiORI', 'casiLTM', 'casiSTM', 'casiLANG', 'casiDRAW', 'casiFLU', 'casiATAJ'].reduce((acc, key) => {
      acc[key] = { type: Number, default: 0 };
      return acc;
    }, {})

  },
  methods: {
    closePage() {
      this.$emit('close');
    },
    async loadData() {
      await this.controller.loadData();
    },
    calculateScores() {
      this.controller.calculateScores();
      this.updateScores();
    },
    updateScores() {
      this.totalScore = this.controller.totalScore || 0;
      this.casiATT = this.controller.casiATT || 0;
      this.casiMMC = this.controller.casiMMC || 0;
      this.casiORI = this.controller.casiORI || 0;
      this.casiLTM = this.controller.casiLTM || 0;
      this.casiSTM = this.controller.casiSTM || 0;
      this.casiLANG = this.controller.casiLANG || 0;
      this.casiDRAW = this.controller.casiDRAW || 0;
      this.casiFLU = this.controller.casiFLU || 0;
      this.casiATAJ = this.controller.casiATAJ || 0;
    },
    loadAllData() {
      try {
        const subjectId = localStorage.getItem('currentSubjectId') || localStorage.getItem('subjectId');
        if (!subjectId) {
          console.error('No subject ID found');
          return;
        }
        
        // Get all subject data
        const allSubjectData = getSubjectData(subjectId);
        
        // Store the full data
        this.jsonData = allSubjectData;
        
        // Extract Clock Drawing score
        this.extractClockDrawingScore(allSubjectData);
        
        // Extract Letter F data
        this.extractLetterFData(allSubjectData);
        
        // Extract Supermarket data
        this.extractSupermarketData(allSubjectData);
        
        // Force a refresh of the component
        this.$forceUpdate();
      } catch (error) {
        console.error('Error loading subject data:', error);
      }
    },
    extractClockDrawingScore(data) {
      // Try to get Clock Drawing score from multiple possible locations
      if (data.clockDrawingData && data.clockDrawingData.clockDrawingScore) {
        this.clockDrawingScore = parseInt(data.clockDrawingData.clockDrawingScore) || 0;
      } else if (data.clockDrawingData && data.clockDrawingData.scoringNotes) {
        this.clockDrawingScore = parseInt(data.clockDrawingData.scoringNotes) || 0;
      } else {
        this.clockDrawingScore = 0;
      }
    },
    extractLetterFData(data) {
      // Try to get Letter F data from multiple possible locations
      let entrySummary = null;
      
      if (data.letterFData && data.letterFData.entrySummary) {
        entrySummary = data.letterFData.entrySummary;
      } else if (data.verbalFluencyLetterFData && data.verbalFluencyLetterFData.entrySummary) {
        entrySummary = data.verbalFluencyLetterFData.entrySummary;
      }
      
      if (entrySummary) {
        this.letterFCorrect = entrySummary.c || 0;
        this.letterFIncorrect = (entrySummary.i || 0) + (entrySummary.ir || 0);
        this.letterFRepetitions = (entrySummary.r || 0) + (entrySummary.ir || 0);
      } else {
        // Default to 0
        this.letterFCorrect = 0;
        this.letterFIncorrect = 0;
        this.letterFRepetitions = 0;
      }
    },
    extractSupermarketData(data) {
      // Try to get Supermarket data from multiple possible locations
      let entrySummary = null;
      
      if (data.supermarketData && data.supermarketData.entrySummary) {
        entrySummary = data.supermarketData.entrySummary;
      } else if (data.verbalFluencySupermarketData && data.verbalFluencySupermarketData.entrySummary) {
        entrySummary = data.verbalFluencySupermarketData.entrySummary;
      }
      
      if (entrySummary) {
        this.supermarketCorrect = entrySummary.c || 0;
        this.supermarketIncorrect = (entrySummary.i || 0) + (entrySummary.ir || 0);
        this.supermarketRepetitions = (entrySummary.r || 0) + (entrySummary.ir || 0);
      } else {
        // Default to 0
        this.supermarketCorrect = 0;
        this.supermarketIncorrect = 0;
        this.supermarketRepetitions = 0;
      }
    },
    startResize(e) {
      e.preventDefault();
      this.isResizing = true;
      this.startX = e.clientX;
      this.startWidth = this.panelWidth;

      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);
    },
    handleResize(e) {
      if (!this.isResizing) return;
      
      const diff = this.startX - e.clientX;
      let newWidth = this.startWidth + diff;
      
      const minWidth = Math.max(775, window.innerWidth * 0.2);
      const maxWidth = window.innerWidth * 0.75;
      newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
      
      this.$emit('resize', newWidth);
    },
    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);
    }
  },
  created() {
    // Listen for data-saved events
    this.unsubscribe = eventBus.on('data-saved', () => {
      // Refresh data when any task data is saved
      this.loadAllData();
    });
    
    // Also refresh data every 2 seconds when panel is open
    this.refreshInterval = setInterval(() => {
      if (this.isOpen) {
        this.loadAllData();
      }
    }, 2000);
  },
  beforeUnmount() {
    // Clean up event listener and interval
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
};
</script>

<style scoped>
.scoring-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  background-color: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  z-index: 1000;
  display: flex;
}

.resize-handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  cursor: ew-resize;
  z-index: 10;
  background-color: transparent;
  transition: background-color 0.2s;
}

.resize-handle:hover {
  background-color: rgba(57, 134, 168, 0.3);
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: white;
  color: #317391;
  border: 2px solid #317391;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  padding: 5px;
  z-index: 1100;
}

.close-btn:hover {
  background-color: #e0e0e0;
  transform: scale(1.1);
}

.close-btn:focus {
  outline: none;
}

.content {
  padding: 20px;
  padding-left: 24px;
  overflow-y: auto;
  height: calc(100% - 40px);
  flex: 1;
  position: relative;
}

.total-score {
  font-weight: bold;
}

.trails-container {
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.trails-section {
  flex: 1;
}

.trail-making-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.trail-section {
  flex: 1;
}

.trail-header {
  font-weight: bold;
  margin-bottom: 5px;
  color: #317391;
}

.trail-values {
  margin-bottom: 5px;
}

.trail-scores {
  display: flex;
  gap: 10px;
}

.trail-scores .score-row {
  flex: 1;
  margin-bottom: 5px;
}

.trail-score-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.trail-score-item .score-box {
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 4px;
  text-align: center;
  min-width: 50px;
  margin-bottom: 5px;
}

.trail-score-item .score-label {
  font-size: 0.875rem;
  color: #666;
  text-align: center;
}

.info-box {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  flex: 0 0 auto;
  min-width: 250px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 0.875rem;
  white-space: nowrap;
  margin-right: 5px;
  color: #333;
}

.info-input-box {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  min-width: 30px;
  max-width: 40px;
  font-size: 0.875rem;
}

.info-input-box-wide {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
  text-align: left;
  flex: 1;
  font-size: 0.875rem;
}

.slash {
  color: #999;
  padding: 0 2px;
}

.info-value {
  font-size: 0.875rem;
  color: #317391;
  font-weight: 500;
}

.toggle-container {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.toggle-btn {
  width: 50px;
  height: 30px;
  background-color: #ccc;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s;
}

.toggle-btn.active {
  background-color: #317391;
}

.toggle-switch {
  display: block;
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.3s;
}

.toggle-btn.active .toggle-switch {
  transform: translateX(20px);
}

.greyed-out {
  opacity: 0.3;
  pointer-events: none;
}

.const-praxis-content {
  display: flex;
  flex-direction: row;
  gap: 30px;
}

.const-praxis-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.const-praxis-label {
  font-weight: bold;
  margin-bottom: 5px;
}

.const-praxis-items {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.const-praxis-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-number {
  font-weight: bold;
}

.const-input {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  width: 50px;
}

.const-shape-label {
  font-size: 0.75rem;
  color: #666;
  min-width: 60px;
}

.const-score-placeholder {
  background-color: #e0e0e0;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: bold;
  color: #666;
}
</style>
